import React from "react";
import { observer } from "mobx-react";
import "./ObVitals.scss";
import Chiclet from "../../../../shared/Chiclet";

function ObVitals(props) {
  return (
    <div className="ob-vitals component">
      {props.model.fields.map((field) => (
        <Chiclet
          key={field.name}
          chart={{
            title: field.name,
            viewCategory: "ob",
            component: (
              <span>
                L-H • Rec
                <br />
                {`${field.rangemin || "--"}–${field.rangemax || "--"} • ${
                  field.value || "--"
                }`}
              </span>
            ),
          }}
          cKey={field.name}
        />
      ))}
    </div>
  );
}

export default observer(ObVitals);
